import React, { useRef, useState } from 'react';
import SingleTabGroup from './SingleTabGroup';
import MoreButton from '../Custom/PopOver/MoreButton';
import PopOver from '../Custom/PopOver/PopOver';
import styles from '../../Template/SingleApplicantTemplate/SingleApplicantPage.module.css';
import moreicon from '../../../assets/Imagess/moreicon.svg';
import exportICon from '../../../assets/Imagess/exportIcon.svg';
import printicon from '../../../assets/Imagess/printIcon.svg';
import { useFetchGenerateInterestedPdf } from '../../../Hooks/SingleApplicant';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { downloadInterestedPdf } from './InterestedPdfExport';
const SingleApplicantNav = ({
  applicant,
  tabContainer,
  selected,
  setSelected,
  handlePrint,
  isInterested = false,
  isExportReady = true,
}) => {
  const { id } = useParams();
  const generatePdf = useFetchGenerateInterestedPdf();
  const exportInProgress = useRef(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleGeneratePdf = async () => {
    if (isInterested && !isExportReady) return;
    if (exportInProgress.current) return;
    exportInProgress.current = true;
    setIsExporting(true);
    try {
      if (isInterested) {
        await downloadInterestedPdf(applicant);
        toast.success('PDF downloaded successfully');
        return;
      }
      const response = await generatePdf.mutateAsync(id);
      const fileURL = response?.data?.fileURL;
      if (!fileURL) {
        toast.error('PDF URL not found');
        return;
      }

      const fileResponse = await fetch(fileURL);
      if (!fileResponse.ok) throw new Error('Failed to retrieve PDF');
      const file = await fileResponse.blob();
      const downloadURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = `Lead_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      // Allow the browser to start saving before releasing the file URL.
      setTimeout(() => URL.revokeObjectURL(downloadURL), 60000);
      toast.success('PDF downloaded successfully');
    } catch (error) {
      console.error('Error downloading PDF:', error);
      toast.error('Failed to download PDF');
    } finally {
      exportInProgress.current = false;
      setIsExporting(false);
    }
  };

  return (
    <div className={styles['tab-singleapp-container']}>
      <SingleTabGroup
        tabContainer={tabContainer}
        selected={selected}
        setSelected={setSelected}
      />
      <MoreButton icon={moreicon} toolTipText='More'>
        <PopOver
          stop
          info={[
            {
              title: isExporting ? 'Exporting...' : isInterested && !isExportReady ? 'Loading details...' : 'Export',
              icon: exportICon,
              handleFunction: isInterested && !isExportReady ? null : handleGeneratePdf,
            },
            {
              title: 'Print',
              icon: printicon,
              handleFunction: handlePrint,
            },
          ]}
        />
      </MoreButton>
    </div>
  );
};

export default SingleApplicantNav;
